import { IconButton, IconClose16, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatPopup.css';
import { getAgentName } from './getAgentName';
import { IOffer } from '../../offer';

interface IChatPopupProps {
  offer: IOffer;
  onClose(): void;
  dates: { checkin: string; checkout: string } | null;
}

export const ChatPopup: React.VFC<IChatPopupProps> = ({ offer, onClose, dates }) => {
  const { user, cianId, dealType, offerType, gaLabel } = offer;

  const [isLoading, setIsLoading] = React.useState(true);

  const companionName = getAgentName(offer);

  const onLoad = () => setIsLoading(false);

  /* istanbul ignore next */
  const src =
    `/dialogs/?hostType=frame&offerId=${cianId}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${companionName ? '&companionName=' + encodeURIComponent(companionName) : ''}` +
    `${user?.cianUserId ? '&companionId=' + encodeURIComponent(user?.cianUserId) : ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&pageType=Listing' +
    `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
    `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}`;

  return (
    <div className={styles['container']}>
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
